import styled from 'styled-components/macro';

export const CalendarControlContainer = styled.div`
  position: relative;
  width: 100%;
`;
